/* 關張傳・第 2 章：宕渠（215 年）
 * 南邊是張飛營，大路往北到前線，再繞到東北的谷口。北邊一條東西向的窄谷（山道迮狹），張郃的縱隊趕著百姓從谷口往西走（往漢中）。
 * 西邊林中有一條小徑（他道）從土人的村子通到谷的中段，起初被藤蔓荊棘封著，要問土人才找得到。 */
export const ROAD_Y = 1300, GORGE = [900, 7300], GAP = [3700, ROAD_Y], CAMP = [4200, 4500], FRONT = [4200, 3200], MOUTH = [7300, ROAD_Y], VILLAGE = [1500, 4300], THICKET = [2450, 3200];
const N = [], S = [];
for (let x = 1100; x <= 7500; x += 640) N.push([x, 830, 400, 240]); // 北邊的山
for (let x = 460; x <= 6400; x += 640) if (Math.abs(x - GAP[0]) > 420) S.push([x, 1780, 400, 240]); // 南邊的山（中段留一個缺口給小徑）
// 小徑走的那一片山林四面是峭壁：只能從南邊的荊棘口（THICKET）進去、從北邊的缺口（GAP）出到谷裡
const R = [];
for (let y = 1750; y <= 3200; y += 240) { R.push([4350, y, 200, 200]); R.push([1700, y, 200, 200]); }
for (let x = 1700; x <= 4350; x += 260) if (Math.abs(x - THICKET[0]) > 180) R.push([x, THICKET[1], 190, 170]);
export default {
  id: 'guanzhang_dangqu', name: '宕渠', W: 8400, H: 5200, seed: 215,
  bases: [CAMP, [7700, ROAD_Y]],
  roads: [
    { pts: [CAMP, FRONT, [5600, 2700], [7200, 2100], MOUTH, [5000, ROAD_Y], [3000, ROAD_Y], [GORGE[0], ROAD_Y], [200, ROAD_Y]], w: 150 },
    { pts: [CAMP, [2800, 4300], VILLAGE], w: 110 },
    { pts: [[2800, 4300], [THICKET[0], THICKET[1] + 300], THICKET, [2500, 2700], [3100, 2200], [GAP[0], 1650], GAP], w: 80 }, // 他道
  ],
  rocks: [...N, ...S, ...R, [6200, 3600, 420, 200], [1200, 2600, 380, 190], [7400, 4300, 380, 180]],
  woods: 0.5,
  sight: 0.8,
  clearings: [[CAMP[0], CAMP[1], 520], [FRONT[0], FRONT[1], 480], [VILLAGE[0], VILLAGE[1], 420], [7400, ROAD_Y, 380], ...[1500, 2600, 3700, 4800, 5900].map((x) => [x, ROAD_Y, 260])],
  villages: [{ x: VILLAGE[0], y: VILLAGE[1], n: 5, r: 280 }],
  tents: [{ x: CAMP[0], y: CAMP[1] + 60, n: 6, r: 380, chief: true, col: '#3e7b50', flag: '張' }],
};
